import { render, staticRenderFns } from "./AddressCard.vue?vue&type=template&id=3b99730d&scoped=true"
import script from "./AddressCard.vue?vue&type=script&lang=ts"
export * from "./AddressCard.vue?vue&type=script&lang=ts"
import style0 from "./AddressCard.vue?vue&type=style&index=0&id=3b99730d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b99730d",
  null
  
)

export default component.exports